import React, { useContext } from "react";
import "./styles.css";
import { Button } from "../Button";
import { quoteContext } from "../../context/quotesContext";
import { ShipmentForm } from "../ShipmentForm";
import { StepFromAndTo } from "../StepFromAndTo";
import { FirstStep } from "../FirstStep";
import { SecondStep } from "../SecondStep";
import arrroeIcon from "../../../public/assets/icon/errorIcon.svg";
import truck from "../../../public/assets/truck.png";
import background from "../../../public/assets/background.png";
import background1024 from "../../../public/assets/backGround1024.png";
import { createShipment } from "../api";
import { HomeLayout } from "../HomeLayout";
import { useTranslation } from "react-i18next";

function FormContainer() {
  const {
    currentStep,
    error,
    handleCancel,
    errorBeforePayment,
    setCurrentSubStep,
    setErrorBeforePayment,
    setLoading,
    mapShipment,
    addressFrom,
    addressTo,
    setCreateShipmentResponse,
    loading,
    setSelectedProvider,
    errorNewAdress
  } = useContext(quoteContext);
  const [t, i18n] = useTranslation();
  const handleRestartToSubstep1 = async () => {
    try {
      setLoading(true);
      const dataToSend = {
        ...mapShipment,
        usa_address_id: addressFrom,
        co_address_id: addressTo,
      };
      const result = await createShipment(dataToSend);
      if (result) {
        if (result.rate_options.length == 0) {
          throw new Error();
        } else {
          setCreateShipmentResponse(result);
          const rates = result.rate_options.map((item) => ({
            id: item.shipment_id_provider + item.shipment_around_usa,
            label: `Proveedor ${item.provider} Costo: ${item.shipment_around_usa}`,
            subText: `Tiempo estimado: ${item.estimated_days} ${
              item.estimated_days > 0 ? "Días" : "Día"
            }`,
            ...item,
          }));
          const provider = rates[0];

          setSelectedProvider(provider);
          setErrorBeforePayment(false);
          setCurrentSubStep(1);
          setLoading(false);
        }
      }
    } catch (error) {
      console.error("Error posting data:", error);
      setErrorBeforePayment(true);
      setLoading(false);
    }
  };

  
  return (
    <HomeLayout showSteps={true}>
      {currentStep === 1 && <FirstStep></FirstStep>}
      {currentStep === 2 && !error && <SecondStep></SecondStep>}
      {error && (
        <div className="error-message-container">
          <img src={arrroeIcon} />
          <p className="error-message">
            {t('unexpected_error_message')}
          </p>
          <Button onClick={() => handleCancel()}>ok</Button>
        </div>
      )}
      {errorBeforePayment && (
        <div className="error-message-container">
          <img src={arrroeIcon} />
          <p className="error-message"> {t('fee_change')}</p>
          <Button onClick={() => handleRestartToSubstep1()}>
            {loading ? t('loading') : t('continue')}
          </Button>
        </div>
      )}
      {errorNewAdress && (
        <div className="error-message-container">
          <img src={arrroeIcon} />
          <p className="error-message"> {t('adress_data_error')}</p>
          <Button onClick={() => handleRestartToSubstep1()}>
            {loading ? t('loading') : t('continue')}
          </Button>
        </div>
      )}
    </HomeLayout>
  );
}

export { FormContainer };
